import { Component, Input, OnInit } from '@angular/core';
import { FractureStimulation } from 'src/app/interfaces/fracture';
import { HandoverService } from 'src/app/services/handover.service';

@Component({
  selector: 'app-handover-detail-fracture-stimulations',
  templateUrl: './handover-detail-fracture-stimulations.component.html',
  styleUrl: './handover-detail-fracture-stimulations.component.scss',
  standalone: false,
})
export class HandoverDetailFractureStimulationsComponent implements OnInit {
  @Input() handoverId: number | undefined;
  @Input() wellName: string | undefined;
  @Input() handoverStatusId: number | undefined;

  fractureStimulations: FractureStimulation[] = [];
  isLoading = false;
  hideFooter = true;
  displayedColumns = [
    'startDate',
    'top',
    'base',
    'fluidType',
    'totalFluid',
    'sandType',
    'totalSand',
    'minimalSurfacePressure',
    'maximalSurfacePressure',
    'rupturePressure',
    'instantPressure',
    'finalSurfacePressure',
    'sandSize',
  ];

  constructor(public handoverService: HandoverService) {}

  ngOnInit(): void {
    if (this.handoverId && this.wellName) {
      this.isLoading = true;
      this.handoverService
        .getHandoverFractureStimulations(
          this.handoverId,
          this.wellName!,
          this.handoverStatusId!
        )
        .subscribe((fs: FractureStimulation[]) => {
          if (fs) {
            fs.sort((a, b) => a.top - b.top);
            this.fractureStimulations = fs;
            this.hideFooter = this.fractureStimulations!.length > 0;
          }
          this.isLoading = false;
        });
    }
  }
}
